<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_v"></a><strong><em>Contents</em></strong></h2>
<p class="toc-front"><a class="nounder" href="#/xhtml/preface#preface">PREFACE</a></p>
<p class="toc-front"><a class="nounder" href="#/xhtml/ack#ack">ACKNOWLEDGMENTS</a></p>
<p class="toc-chap"><a class="nounder" href="#/xhtml/chap01#ch01">1. THIS MAN IS NOT A NUT</a></p>
<p class="toc-chap"><a class="nounder" href="#/xhtml/chap02#ch02">2. SECRECY IS OBVIOUSLY ESSENTIAL</a></p>
<p class="toc-chap"><a class="nounder" href="#/xhtml/chap03#ch03">3. THE SUGGESTION IS RETURNED AS IMPRACTICAL</a></p>
<p class="toc-chap"><a class="nounder" href="#/xhtml/chap04#ch04">4. THE ARMY AIR FORCES WILL COOPERATE</a></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/chap05#ch05" title="Link target outside of Sample">5. FLAMETHROWER</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/chap06#ch06" title="Link target outside of Sample">6. NO QUESTIONS WILL BE TOLERATED</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/chap07#ch07" title="Link target outside of Sample">7. THEY CAN FLY!</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/chap08#ch08" title="Link target outside of Sample">8. CHEMICAL WARFARE CONCLUDES</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/chap09#ch09" title="Link target outside of Sample">9. THE BAT-SHIT MAN</span></p>
<p class="toc-chap1"><span class="nounder" href="#/xhtml/chap10#ch10" title="Link target outside of Sample">10. OZRO</span></p>
<p class="toc-chap1"><span class="nounder" href="#/xhtml/chap11#ch11" title="Link target outside of Sample">11. OSAKA BAY</span></p>
<p class="toc-chap1"><span class="nounder" href="#/xhtml/chap12#ch12" title="Link target outside of Sample">12. MUROC</span></p>
<p class="toc-chap1"><span class="nounder" href="#/xhtml/chap13#ch13" title="Link target outside of Sample">13. CARLSBAD</span></p>
<p class="toc-chap1"><span class="nounder" href="#/xhtml/chap14#ch14" title="Link target outside of Sample">14. BANDERA</span></p>
<p class="toc-chap1"><span class="nounder" href="#/xhtml/chap15#ch15" title="Link target outside of Sample">15. PROJECT X-RAY</span></p>
<p class="toc-chap1"><span class="nounder" href="#/xhtml/chap16#ch16" title="Link target outside of Sample">16. THE OTHER WAR</span></p>
<p class="toc-chap1"><span class="nounder" href="#/xhtml/chap17#ch17" title="Link target outside of Sample">17. THE HIBERNATION EQUATION</span></p>
<p class="toc-chap1"><span class="nounder" href="#/xhtml/chap18#ch18" title="Link target outside of Sample">18. THE FISTFIGHT</span></p>
<p class="toc-chap1"><span class="nounder" href="#/xhtml/chap19#ch19" title="Link target outside of Sample">19. DUGWAY</span></p>
<p class="toc-chap1"><span class="nounder" href="#/xhtml/chap20#ch20" title="Link target outside of Sample">20. IT’S A BIT “STICKY” IN EL CENTRO</span></p>
<p class="toc-back"><em>Photographs Following Page</em></p>
<p class="toc-back"><span class="nounder" href="#/xhtml/epilogue#epilogue" title="Link target outside of Sample">EPILOGUE</span></p>
<p class="toc-back"><span class="nounder" href="#/xhtml/references#references" title="Link target outside of Sample">REFERENCES</span></p>
<p class="toc-back"><span class="nounder" href="#/xhtml/index#index" title="Link target outside of Sample">INDEX</span> <a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?704315dc